<ng-container *transloco="let t">
  <div mat-dialog-content style="margin: 0px !important; padding: 0px !important;">
    <div class="icu-color-grid">
      <button *ngFor="let color of colors" (click)="onSelectClick(color)" class="icu-color-item"
        [ngStyle]="{'background-color': color.value}" mat-icon-button></button>
    </div>
  </div>
  <div mat-dialog-actions style="display: flex; align-items: center; justify-content: center; min-height:fit-content;
  margin-bottom:0px !important;">
    <button (click)="onCancelClick()" mat-raised-button cdkFocusInitial style="padding: 0px 10px;
    height: 25px;
    display: flex;
    align-items: center;">
      <span>{{t('Cancel')}}</span>
    </button>
  </div>
</ng-container>
